import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { find } from "lodash";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, IconButton } from "@mui/material";
import PauseIcon from "@mui/icons-material/Pause";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { Box } from "@mui/system";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import { currentAssetSliceActions } from "../../../Store/Slices/CurrentAssetSlice";
import "./style.css";
import ReadAlong from "../../../Js/read-along";
import RecordButton from "../../../Components/Media/RecordButton";
import { audioVideoSliceActions } from "../../../Store/Slices/AudioVideoSlice";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";

let readAlong = new ReadAlong();

var initLogObj = {
  attempts: 1,
  duration: 0,
  assetType: {
    group: "presentation",
    value: null,
  },
  userAnswer: [],
  isEvaluated: "auto",
  actualAnswer: [],
  genericScore: 1,
};

const RA = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const classes = useStyles();
  let [isChat, setIsChat] = useState(false);
  let [words, setWords] = useState([]);
  let [isplay, setIsplay] = useState(false);
  let [audio, setAudio] = useState(null);
  let [members, setMembers] = useState([]);
  let [chatWords, setChatWords] = useState([]);
  let [logObj, setLogObj] = useState(initLogObj);
  let [recordedAudio, setRecordedAudio] = useState(null);
  let [ismute, setIsmute] = useState(false);

  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const { recordingContinueIndex, recordingAudioContinueIndex } = useSelector(
    (state) => state.currentAsset
  );

  const { audioPlaying } = useSelector((state) => state.audioVideo);

  useEffect(() => {
    if (!audioPlaying && document.getElementById("passage-audio")) {
      document.getElementById("passage-audio").pause();
      setIsplay(false);
    }
  }, [audioPlaying]);

  useEffect(() => {
    if (props.content && props.content.epage.options.content[0]["data"]) {
      console.log("props.content", props.content);
      let members = props.content.epage.options.content[0]["data"]["members"];
      let raWords = props.content.epage.options.content[0]["data"]["words"];
      setWords(raWords);
      if (
        props.content.epage.options.content[0]["data"] &&
        props.content.epage.options.content[0]["data"]["media"] &&
        props.content.epage.options.content[0]["data"]["media"]["audio"]
      ) {
        setAudio(
          props.content.epage.options.content[0]["data"]["media"]["audio"]
        );
      }
      setMembers(props.content.epage.options.content[0]["data"]["members"]);
      if (members[0]["name"].length > 0) {
        setIsChat(true);
        let arr = [];
        let wordspan = [];
        let leftside = raWords[0]["member"] == 0 ? true : false;
        var currentMember = 0;
        for (let x = 0; x < raWords.length; x++) {
          let wordSplit = raWords[x]["word"].split("<p>");
          if (raWords[x]["member"] != null) {
            currentMember = raWords[x]["member"];
            leftside = currentMember == 0 ? true : false;
          }
          wordspan.push({
            word: wordSplit[0],
            begin: raWords[x]["begin"],
            duration: raWords[x]["duration"],
          });
          if (
            raWords[x]["word"].indexOf("<p>") !== -1 ||
            x == raWords.length - 1
          ) {
            let obj = {
              leftSide: leftside,
              image: members[currentMember]["image"],
              words: wordspan,
            };
            arr.push(obj);
            wordspan = [];
          }
        }
        console.log("RRRRRR", arr);
        setChatWords(arr);
      } else {
        setIsChat(false);
      }
      setLogObj({
        ...logObj,
        assetType: {
          ...logObj.assetType,
          value: props.content.info.asset_type_alias,
        },
      });
    }
  }, [props.content]);

  useEffect(() => {
    dispatch(currentAssetSliceActions.setAssetLogObj(logObj));
  }, [logObj]);

  const playPause = () => {
    try {
      var args;
      args = {
        text_element: isChat
          ? document.getElementById("passage-text1")
          : document.getElementById("passage-text"),
        audio_element: document.getElementById("passage-audio")
          ? document.getElementById("passage-audio")
          : "",
        autofocus_current_word: true,
      };
      readAlong.init(args);
    } catch (err) {
      console.log(err, " : error");
    }
    //console.log(this.audio, " : hhhhh");
    var a = document.getElementById("passage-audio");
    console.log("!@#$222333444", a);

    if (!isplay) {
      a.play();
      dispatch(audioVideoSliceActions.setAudioIsPlaying(true));
      dispatch(audioVideoSliceActions.setCurrentAudioSrc(null));
      setIsplay(true);
    } else {
      a.pause();
      dispatch(audioVideoSliceActions.setAudioIsPlaying(false));
      setIsplay(false);
    }
    // let that = this;
    a.onended = () => {
      //props.togglePlay(false);
      dispatch(audioVideoSliceActions.setAudioIsPlaying(false));
      setIsplay(false);
    };
  };

  const muteOnOff = () => {
    var a = document.getElementById("passage-audio");
    if (a.muted) {
      a.muted = false;
      setIsmute(false);
    } else {
      a.muted = true;
      setIsmute(true);
    }
  };

  return (
    <div>
      {props.content && (
        <Grid item xs={12} sx={{}}>
          <Box
            sx={{
              borderColor: "#EAECEE",
              borderRadius: 5,
              py: 0,
              mx: 6,
              mt: 1,
              height: "59vh",
            }}
          >
            <p class="passage-audio">
              {audio && (
                <audio
                  id="passage-audio"
                  class="passage"
                  src={`${sessionStorage.getItem("media_url")}audio/${audio}`}
                >
                  <em class="error">
                    <strong>Error:</strong> Your browser doesn't appear to
                    support HTML5 Audio.
                  </em>
                </audio>
              )}
            </p>
            <Grid
              container
              sx={{
                flexDirection: "row",
                flexFlow: "wrap",
                justifyContent: "center",
                px: 2,
                gap: 1,
              }}
            >
              {/* <Grid item xs={4} sx={{ textAlign: 'center', mt: 3 }}>
                            <CBTMedia />
                        </Grid> */}
              {!isChat && (
                <Grid item xs={12}>
                  <Box
                    className={classes.scrollBar}
                    sx={{
                      color: "#DB8829",
                      textAlign: "justify",
                      boxShadow: 0,
                      height: "55vh",
                      pl: 2,
                      pr: 2,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "1.1rem",
                        fontWeight: "500",
                        lineHeight: 1.9,
                        letterSpacing: "1.3px",
                        lineHeight: 2,
                        "@media (min-width: 1636px)": { fontSize: "1.7rem" },
                      }}
                      id="passage-text"
                      className="passage paragraphspan1 initialized"
                    >
                      <p style={{}}>
                        {words &&
                          words.map((val, index) => {
                            if (val.word.indexOf("<p>") != -1) {
                              return (
                                <>
                                  <span
                                    data-begin={val.begin}
                                    data-dur={val.duration}
                                  >
                                    {val.word.split("<p>")[0]}
                                  </span>
                                  <p style={{ display: "block" }}></p>
                                </>
                              );
                            } else {
                              return (
                                <span
                                  data-begin={val.begin}
                                  data-dur={val.duration}
                                >
                                  {val.word}
                                </span>
                              );
                            }
                          })}
                      </p>
                    </Typography>
                  </Box>
                </Grid>
              )}
              {isChat && (
                <Grid item xs={12}>
                  <Box
                    className={classes.scrollBar}
                    sx={{
                      color: "#DB8829",
                      textAlign: "justify",
                      boxShadow: 0,
                      pl: 2,
                      pr: 2,
                    }}
                  >
                    <Grid
                      item
                      sx={{}}
                      id="passage-text1"
                      className="passage paragraphspan1 initialized"
                    >
                      {chatWords && (
                        <>
                          {chatWords.map((val, index) => {
                            return (
                              <>
                                {val.leftSide && (
                                  <Grid container sx={{ flexDirection: "row" }}>
                                    <Grid item sx={{ alignSelf: "center" }}>
                                      <ListItemAvatar>
                                        <Avatar
                                          alt="Remy Sharp"
                                          src={`${sessionStorage.getItem(
                                            "media_url"
                                          )}image/${val.image}`}
                                          sx={{
                                            border: "3px solid #DB8829",
                                            borderStyle: "double",
                                            backgroundColor: "#F5F7FF",
                                            padding: "0.1rem",
                                            "@media (min-width: 1636px)": {
                                              width: 60,
                                              height: 60,
                                            },
                                          }}
                                        />
                                      </ListItemAvatar>
                                    </Grid>
                                    <Grid
                                      item
                                      sx={{
                                        alignSelf: "center",
                                        backgroundColor: "#e5ecff",
                                        padding: "10px",
                                        my: 2,
                                        borderRadius: "15px",
                                        minwidth: 0,
                                        maxWidth: "80%",
                                        "@media (min-width: 1636px)": {
                                          maxWidth: "90%",
                                          ml: 1,
                                        },
                                      }}
                                    >
                                      <ListItemText
                                        disableTypography={true}
                                        sx={{
                                          fontSize: "1.2rem",
                                          fontWeight: 600,
                                          color: "primary.main",
                                          "@media (min-width: 1636px)": {
                                            fontSize: "1.5rem",
                                            pl: 2,
                                          },
                                        }}
                                      >
                                        {val.words.map((word, ind) => {
                                          return (
                                            <span
                                              data-begin={word.begin}
                                              data-dur={word.duration}
                                            >
                                              {word.word}
                                            </span>
                                          );
                                        })}
                                      </ListItemText>
                                    </Grid>
                                  </Grid>
                                )}
                                {!val.leftSide && (
                                  <Grid
                                    container
                                    sx={{
                                      flexDirection: "row",
                                      justifyContent: "flex-end",
                                      textAlign: "end",
                                      marginTop: 1,
                                    }}
                                  >
                                    <Grid
                                      item
                                      sx={{
                                        alignSelf: "center",
                                        minwidth: 0,
                                        maxWidth: "80%",
                                        backgroundColor: "#ffd89b",
                                        padding: "10px",
                                        paddingLeft: "18px",
                                        borderRadius: "15px",
                                        mr: 1,
                                        "@media (min-width: 1636px)": {
                                          maxWidth: "90%",
                                        },
                                      }}
                                    >
                                      <Typography
                                        disableTypography={true}
                                        sx={{
                                          textAlign: "start",
                                          pr: 1,
                                          fontSize: "1.2rem",
                                          fontWeight: 600,
                                          color: "primary.main",
                                          "@media (min-width: 1636px)": {
                                            fontSize: "1.5rem",
                                          },
                                        }}
                                      >
                                        {val.words.map((word, ind) => {
                                          return (
                                            <span
                                              data-begin={word.begin}
                                              data-dur={word.duration}
                                            >
                                              {word.word}
                                            </span>
                                          );
                                        })}
                                      </Typography>
                                    </Grid>
                                    <Grid item sx={{ alignSelf: "center" }}>
                                      <ListItemAvatar sx={{}}>
                                        <Avatar
                                          alt="Remy Sharp"
                                          src={`${sessionStorage.getItem(
                                            "media_url"
                                          )}image/${val.image}
                                        `}
                                          sx={{
                                            border: "3px solid #ffa723",
                                            borderStyle: "double",
                                            backgroundColor: "#F5F7FF",
                                            padding: "0.1rem",
                                            "@media (min-width: 1636px)": {
                                              width: 60,
                                              height: 60,
                                            },
                                          }}
                                        />
                                      </ListItemAvatar>
                                    </Grid>
                                  </Grid>
                                )}
                              </>
                            );
                          })}
                        </>
                      )}
                    </Grid>
                  </Box>
                </Grid>
              )}
            </Grid>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: 1,
            }}
          >
            <IconButton
              sx={{
                mx: 1,
                border: 1,
                borderColor: "#EFEFEF",
                backgroundColor: "primary.main",
                boxShadow: 2,
                color: "#FFFFFF",
              }}
              size="medium"
              onClick={muteOnOff}
              disabled={!isplay}
            >
              {ismute ? (
                <VolumeUpIcon
                  sx={{
                    "@media (min-width: 1636px)": {
                      fontSize: "2rem",
                    },
                  }}
                />
              ) : (
                <VolumeOffIcon
                  sx={{
                    "@media (min-width: 1636px)": {
                      fontSize: "2rem",
                    },
                  }}
                />
              )}
            </IconButton>
            <IconButton
              sx={{
                mx: 1,
                border: 1,
                borderColor: "#EFEFEF",
                backgroundColor: "primary.main",
                boxShadow: 2,
                color: "#FFFFFF",
              }}
              size="medium"
              onClick={playPause}
              disabled={
                recordingContinueIndex != -1 ||
                recordingAudioContinueIndex != -1
              }
            >
              {isplay ? (
                <PauseIcon
                  sx={{
                    "@media (min-width: 1636px)": {
                      fontSize: "2rem",
                    },
                  }}
                />
              ) : (
                <PlayArrowIcon
                  sx={{
                    "@media (min-width: 1636px)": {
                      fontSize: "2rem",
                    },
                  }}
                />
              )}
            </IconButton>
            {/* <RecordButton
              size="medium"
              checkOnPause={false}
              index={0}
              alreadyRecorded={recordedAudio ? recordedAudio : null}
              recordedAudio={(audio) => {
                setRecordedAudio(audio);
              }}
              uploadOnPause={
                userInfo.rolesInfo.title.toLowerCase() == "learner"
              }
              disabled={recordingAudioContinueIndex != -1 || isplay}
              audioDisable={recordingContinueIndex != -1 || isplay}
            ></RecordButton> */}
          </Box>
        </Grid>
      )}
    </div>
  );
};
const useStyles = makeStyles({
  ListItemText: {
    fontSize: "1rem !important",
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
    height: "53vh",
    overflow: "auto",
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});
export default RA;
